import React, { useState, useEffect } from 'react';
import DropDown from '../DropDown';
import { DataItem } from '../../services/apiSLTP/activities';
import { updateActivity } from '../../services/apiSLTP/planning';
import { activityTypeEnum } from '../../utils/enums';
import { useAuth } from '../../hooks/useAuth';
import { ActivityType } from '../../services/apiSLTP/dailyReports/activityTypes';

interface ActivityNeedsCellProps {
    activity: DataItem;
    activitiesTypes?: ActivityType[];
    disabled?: boolean;
    refetch: () => void;
    isLoading?: boolean;
}

const ActivityNeedsCell: React.FC<ActivityNeedsCellProps> = React.memo(({ activity, activitiesTypes, disabled = false, refetch, isLoading }) => {
    const [dropdownLoaded, setDropdownLoaded] = useState(true);

    const { user } = useAuth();

    const moTruckId = '66b097d4b0a672302822c715';
    const moAmplirollId = '66e14538c7639ac65e2e6763';

    const handleActivityChange = async (activityType: { label: string; value: string }) => {
        await updateActivity(activity._id, { activityTypeId: activityType.value });
        refetch();
    };

    const selectedActivityType = () => {
        return { value: activity.activityTypeId._id, label: activity.activityTypeId.designation };
    };

    return (
        <div>
            {activity.siteId.conducId?._id === user?._id || activity.siteId.assistantConducId?._id === user?._id ? (
                <div style={{ position: 'absolute', left: 0, width: '100%' }}>
                    <DropDown
                        selectedItem={selectedActivityType()}
                        items={
                            activitiesTypes
                                ?.filter((activityType) =>
                                    [moAmplirollId, moTruckId].includes(activity.reportId.userId._id)
                                        ? activityType.type === activityTypeEnum.TRUCK
                                        : activityType.type !== activityTypeEnum.TRUCK
                                )
                                .map((value) => ({ label: value.designation, value: value._id })) || []
                        }
                        inputLabel=""
                        handleChange={(event, value) => handleActivityChange({ value: value?.value || '', label: value?.label || '' })}
                        disabled={disabled}
                        formClassName="pad-0-imp w-200px-imp"
                        loading={isLoading}
                    />
                </div>
            ) : (
                <span>{selectedActivityType().label}</span>
            )}
        </div>
    );
});

export default ActivityNeedsCell;
